import { createApi } from '@reduxjs/toolkit/query/react'
import { baseUrl } from './axiosInstance'
import axiosBaseQuery from './axiosBaseQuery'

const ruleApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'ruleApi',
  tagTypes: ['ruleApi'],
  endpoints: () => ({})
})

export default ruleApi
